import { z } from "zod";

// CourtTemplate validation schemas -- iteration 028 (simplified, TemplateMount removed)

export const createCourtTemplateSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  court_type_id: z.string().min(1, "Court type is required"),
  is_default: z.boolean().optional(),
});

export const updateCourtTemplateSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  is_default: z.boolean().optional(),
});

export type CreateCourtTemplateInput = z.infer<typeof createCourtTemplateSchema>;
export type UpdateCourtTemplateInput = z.infer<typeof updateCourtTemplateSchema>;
